import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import {
  Stack,
} from '@fluentui/react';
import { SurveyContext } from '@bingads-webui-campaign-react/survey-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { surveyStyles } from '../../styles';
import { SurveyContextType } from '../../survey-context';

export const SurveyView = React.memo((props) => {
  const classes:any = useDefaultStyles(() => surveyStyles);

  // @ts-ignore
  const surveyContext : SurveyContextType = useContext(SurveyContext);

  const {
    surveyConfigurator,
    getIsEndingPage,
    getPageIndex,
  } = surveyContext;

  const isEndingPage = getIsEndingPage();
  const pageIndex = getPageIndex();

  const page = useMemo(() => (isEndingPage ?
    surveyConfigurator.getEndingPage() :
    surveyConfigurator.getPage(pageIndex)), [surveyConfigurator, isEndingPage, pageIndex]);
  const PageView = useMemo(() => page.getView(), [page]);

  const {
    style,
  } = surveyConfigurator.getConfiguration();

  const customizedClasses: any = useDefaultStyles(() => style);

  return (
    <Stack className={classNames(customizedClasses.root, classes.container, 'survey-container')} >
      <PageView
        key={`survey-page-${pageIndex}`}
        classes={classes}
      />
    </Stack>
  );
});
